import React from 'react';

const benefitsData = [
  {
    benefit: 'Relationship',
    description: 'Dedicated partner account manager.',
  },
  {
    benefit: 'Support',
    description: 'Large deal support.',
  },
  {
    benefit: 'Demand',
    description:
      'Sales referrals will be offered by Anacle for all business leads that are within your geographical location.',
  },
  {
    benefit: 'Training',
    description: 'Dedicated sales, product and technical training.',
  },
  {
    benefit: 'Advertising',
    description: 'Online advertising space at Anacle website.',
  },
  {
    benefit: 'New Products',
    description: 'Invitation to all Anacle new product launches.',
  },
  {
    benefit: 'Publicity',
    description:
      'Advertisement on all Anacle’s print and electronic media publications.',
  },
  {
    benefit: 'Pricing',
    description:
      'Preferred discounts for all carried Anacle products and solutions.',
  },
  {
    benefit: 'Events',
    description: 'Support for co-events, co-presentations, and co-exhibitions.',
  },
];

export default function Benefit() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 bg-gray-100">
      <div className="col-span-1"></div>
      <div className="col-span-4 mx-auto py-14">
        <h1 className="text-4xl mb-4 whitespace-pre-line leading-normal">
          {'Exclusive Value-Added Reseller Benefits'}
        </h1>

        <div className="overflow-x-auto">
          <table className="w-full table-fixed text-sm">
            <thead>
              <tr className="text-left text-[#BF984D] border-b border-gray-700">
                <th className="text-base font-medium">Criteria</th>
                <th className="w-3/4 text-base font-medium text-start">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              {benefitsData.map((item, index) => (
                <tr
                  key={index}
                  className={`text-sm ${
                    index === benefitsData.length - 1
                      ? ''
                      : 'border-b border-gray-300'
                  }`}
                >
                  <td className="py-6 text-lg font-medium">{item.benefit}</td>
                  <td className="py-3 text-start tracking-wide whitespace-pre-line">
                    {item.description}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
